/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import _get from 'lodash/get'
import { tokenService } from 'services/Token'
import { analytics } from 'services/Analytics'
import { USER_LOGOUT_ACTION } from 'constants/user'
import { ROUTES } from 'constants/routes'
import { refresh, logout } from 'api/client/actions/auth'
import { updateUserRole } from 'redux-app/modules/auth'
import { getToken } from 'redux-app/selectors/auth'
import { history } from 'utils/location'

export const onStartLogout = ({ isRedirectToLogin } = { isRedirectToLogin: false }) => (dispatch, getState) => {
  
  const accessToken = _get(getToken(getState()), 'access')
  const refreshToken = _get(getToken(getState()), 'refresh')

  dispatch(logout({ authToken: accessToken, refreshToken: refreshToken }))
  
  dispatch(onFinishLogout({ isRedirectToLogin }))
}

export const onFinishLogout = ({ isRedirectToLogin }) => dispatch => {
  analytics.logout()
  dispatch({
    type: USER_LOGOUT_ACTION,
  })

  if (isRedirectToLogin) {
    history.push(ROUTES.home.logIn)
  }
}

export const onStartLogoutWithRedirect = () => dispatch => dispatch(onStartLogout({ isRedirectToLogin: true }))

export const onCheckAuth = () => (dispatch, getState) => {
  const accessToken = _get(getToken(getState()), 'access')
  const refreshToken = _get(getToken(getState()), 'refresh')

  if (refreshToken && tokenService.isTokenExpired(accessToken)) {
    return dispatch(onRefreshToken())
  }
  return Promise.resolve(accessToken)
}

export const onRefreshToken = () => (dispatch, getState) => {
  const refreshToken = _get(getToken(getState()), 'refresh')

  if (!refreshToken) {
    return Promise.reject(new Error('no_refresh_token'))
  }

  return dispatch(refresh({ refresh_token: refreshToken }))
    .then(({ value: { result: { access_token: accessToken } } }) => {
      const { role } = tokenService.getTokenPayload(accessToken)
      dispatch(updateUserRole(role))
      return accessToken
    })
}
